// store/Automation/actionType.js

///automationscenario/data (list)
export const AUTOMATION_SCENARIO_LIST = "AUTOMATION_SCENARIO_LIST";
export const AUTOMATION_SCENARIO_LIST_SUCCESS = "AUTOMATION_SCENARIO_LIST_SUCCESS";
export const AUTOMATION_SCENARIO_LIST_FAILURE = "AUTOMATION_SCENARIO_LIST_FAILURE";
///automationscenario/status/data
export const AUTOMATION_SCENARIO_STATUS_LIST = "AUTOMATION_SCENARIO_STATUS_LIST";
export const AUTOMATION_SCENARIO_STATUS_LIST_SUCCESS = "AUTOMATION_SCENARIO_STATUS_LIST_SUCCESS";
export const AUTOMATION_SCENARIO_STATUS_LIST_FAILURE = "AUTOMATION_SCENARIO_STATUS_LIST_FAILURE";
///automationscenario/canvas/{id}
export const AUTOMATION_CANVAS = "AUTOMATION_CANVAS";
export const AUTOMATION_CANVAS_SUCCESS = "AUTOMATION_CANVAS_SUCCESS";
export const AUTOMATION_CANVAS_FAILURE = "AUTOMATION_CANVAS_FAILURE";
///automationscenario/data (create)
export const AUTOMATION_SCENARIO_CREATE = "AUTOMATION_SCENARIO_CREATE";
export const AUTOMATION_SCENARIO_CREATE_SUCCESS = "AUTOMATION_SCENARIO_CREATE_SUCCESS";
export const AUTOMATION_SCENARIO_CREATE_FAILURE = "AUTOMATION_SCENARIO_CREATE_FAILURE";
///automationscenario/data/{id} (update)
export const AUTOMATION_SCENARIO_UPDATE = "AUTOMATION_SCENARIO_UPDATE";
export const AUTOMATION_SCENARIO_UPDATE_SUCCESS = "AUTOMATION_SCENARIO_UPDATE_SUCCESS";
export const AUTOMATION_SCENARIO_UPDATE_FAILURE = "AUTOMATION_SCENARIO_UPDATE_FAILURE";
///automationscenario/publish/{id}
export const AUTOMATION_SCENARIO_PUBLISH = "AUTOMATION_SCENARIO_PUBLISH";
export const AUTOMATION_SCENARIO_PUBLISH_SUCCESS = "AUTOMATION_SCENARIO_PUBLISH_SUCCESS";
export const AUTOMATION_SCENARIO_PUBLISH_FAILURE = "AUTOMATION_SCENARIO_PUBLISH_FAILURE";
///automationscenario/duplicate/{id}
export const AUTOMATION_SCENARIO_DUPLICATE = "AUTOMATION_SCENARIO_DUPLICATE";
export const AUTOMATION_SCENARIO_DUPLICATE_SUCCESS = "AUTOMATION_SCENARIO_DUPLICATE_SUCCESS";
export const AUTOMATION_SCENARIO_DUPLICATE_FAILURE = "AUTOMATION_SCENARIO_DUPLICATE_FAILURE";
///automationscenario/disable/{id}
export const AUTOMATION_SCENARIO_DISABLE = "AUTOMATION_SCENARIO_DISABLE";
export const AUTOMATION_SCENARIO_DISABLE_SUCCESS = "AUTOMATION_SCENARIO_DISABLE_SUCCESS";
export const AUTOMATION_SCENARIO_DISABLE_FAILURE = "AUTOMATION_SCENARIO_DISABLE_FAILURE";
///automationscenario/data/{id} (delete)
export const AUTOMATION_SCENARIO_DELETE = "AUTOMATION_SCENARIO_DELETE";
export const AUTOMATION_SCENARIO_DELETE_SUCCESS = "AUTOMATION_SCENARIO_DELETE_SUCCESS";
export const AUTOMATION_SCENARIO_DELETE_FAILURE = "AUTOMATION_SCENARIO_DELETE_FAILURE";

///automationscenarionode/data (create)
export const AUTOMATION_NODE_CREATE = "AUTOMATION_NODE_CREATE";
export const AUTOMATION_NODE_CREATE_SUCCESS = "AUTOMATION_NODE_CREATE_SUCCESS";
export const AUTOMATION_NODE_CREATE_FAILURE = "AUTOMATION_NODE_CREATE_FAILURE";
///automationscenarionode/data/{id} (update)
export const AUTOMATION_NODE_UPDATE = "AUTOMATION_NODE_UPDATE";
export const AUTOMATION_NODE_UPDATE_SUCCESS = "AUTOMATION_NODE_UPDATE_SUCCESS";
export const AUTOMATION_NODE_UPDATE_FAILURE = "AUTOMATION_NODE_UPDATE_FAILURE";
///automationscenarionode/data/{id} (delete)
export const AUTOMATION_NODE_DELETE = "AUTOMATION_NODE_DELETE";
export const AUTOMATION_NODE_DELETE_SUCCESS = "AUTOMATION_NODE_DELETE_SUCCESS";
export const AUTOMATION_NODE_DELETE_FAILURE = "AUTOMATION_NODE_DELETE_FAILURE";

///automationscenariofnodelink/data (create)
export const AUTOMATION_LINK_CREATE = "AUTOMATION_LINK_CREATE";
export const AUTOMATION_LINK_CREATE_SUCCESS = "AUTOMATION_LINK_CREATE_SUCCESS";
export const AUTOMATION_LINK_CREATE_FAILURE = "AUTOMATION_LINK_CREATE_FAILURE";
///automationscenariofnodelink/data/{id} (delete)
export const AUTOMATION_LINK_DELETE = "AUTOMATION_LINK_DELETE";
export const AUTOMATION_LINK_DELETE_SUCCESS = "AUTOMATION_LINK_DELETE_SUCCESS";
export const AUTOMATION_LINK_DELETE_FAILURE = "AUTOMATION_LINK_DELETE_FAILURE";

///automationblock/{id}/configfields
export const AUTOMATION_BLOCK_CONFIG_FIELDS = "AUTOMATION_BLOCK_CONFIG_FIELDS";
export const AUTOMATION_BLOCK_CONFIG_FIELDS_SUCCESS = "AUTOMATION_BLOCK_CONFIG_FIELDS_SUCCESS";
export const AUTOMATION_BLOCK_CONFIG_FIELDS_FAILURE = "AUTOMATION_BLOCK_CONFIG_FIELDS_FAILURE";

///automationscenariofnodeconfig/data (save)
export const AUTOMATION_NODE_CONFIG_SAVE = "AUTOMATION_NODE_CONFIG_SAVE";
export const AUTOMATION_NODE_CONFIG_SAVE_SUCCESS = "AUTOMATION_NODE_CONFIG_SAVE_SUCCESS";
export const AUTOMATION_NODE_CONFIG_SAVE_FAILURE = "AUTOMATION_NODE_CONFIG_SAVE_FAILURE";
///automationscenariofnodeconfig/data/{id} (delete)
export const AUTOMATION_NODE_CONFIG_DELETE = "AUTOMATION_NODE_CONFIG_DELETE";
export const AUTOMATION_NODE_CONFIG_DELETE_SUCCESS = "AUTOMATION_NODE_CONFIG_DELETE_SUCCESS";
export const AUTOMATION_NODE_CONFIG_DELETE_FAILURE = "AUTOMATION_NODE_CONFIG_DELETE_FAILURE";

///automationdelayconfig/data (create)
export const AUTOMATION_DELAY_CREATE = "AUTOMATION_DELAY_CREATE";
export const AUTOMATION_DELAY_CREATE_SUCCESS = "AUTOMATION_DELAY_CREATE_SUCCESS";
export const AUTOMATION_DELAY_CREATE_FAILURE = "AUTOMATION_DELAY_CREATE_FAILURE";
///automationdelayconfig/data/{id} (update)
export const AUTOMATION_DELAY_UPDATE = "AUTOMATION_DELAY_UPDATE";
export const AUTOMATION_DELAY_UPDATE_SUCCESS = "AUTOMATION_DELAY_UPDATE_SUCCESS";
export const AUTOMATION_DELAY_UPDATE_FAILURE = "AUTOMATION_DELAY_UPDATE_FAILURE";

///automationcondition/group/data (create)
export const AUTOMATION_CONDITION_GROUP_CREATE = "AUTOMATION_CONDITION_GROUP_CREATE";
export const AUTOMATION_CONDITION_GROUP_CREATE_SUCCESS = "AUTOMATION_CONDITION_GROUP_CREATE_SUCCESS";
export const AUTOMATION_CONDITION_GROUP_CREATE_FAILURE = "AUTOMATION_CONDITION_GROUP_CREATE_FAILURE";
///automationcondition/group/data/{id} (update)
export const AUTOMATION_CONDITION_GROUP_UPDATE = "AUTOMATION_CONDITION_GROUP_UPDATE";
export const AUTOMATION_CONDITION_GROUP_UPDATE_SUCCESS = "AUTOMATION_CONDITION_GROUP_UPDATE_SUCCESS";
export const AUTOMATION_CONDITION_GROUP_UPDATE_FAILURE = "AUTOMATION_CONDITION_GROUP_UPDATE_FAILURE";
///automationcondition/group/data/{id} (delete)
export const AUTOMATION_CONDITION_GROUP_DELETE = "AUTOMATION_CONDITION_GROUP_DELETE";
export const AUTOMATION_CONDITION_GROUP_DELETE_SUCCESS = "AUTOMATION_CONDITION_GROUP_DELETE_SUCCESS";
export const AUTOMATION_CONDITION_GROUP_DELETE_FAILURE = "AUTOMATION_CONDITION_GROUP_DELETE_FAILURE";

///automationcondition/rule/data (create)
export const AUTOMATION_CONDITION_RULE_CREATE = "AUTOMATION_CONDITION_RULE_CREATE";
export const AUTOMATION_CONDITION_RULE_CREATE_SUCCESS = "AUTOMATION_CONDITION_RULE_CREATE_SUCCESS";
export const AUTOMATION_CONDITION_RULE_CREATE_FAILURE = "AUTOMATION_CONDITION_RULE_CREATE_FAILURE";
///automationcondition/rule/data/{id} (update)
export const AUTOMATION_CONDITION_RULE_UPDATE = "AUTOMATION_CONDITION_RULE_UPDATE";
export const AUTOMATION_CONDITION_RULE_UPDATE_SUCCESS = "AUTOMATION_CONDITION_RULE_UPDATE_SUCCESS";
export const AUTOMATION_CONDITION_RULE_UPDATE_FAILURE = "AUTOMATION_CONDITION_RULE_UPDATE_FAILURE";
///automationcondition/rule/data/{id} (delete)
export const AUTOMATION_CONDITION_RULE_DELETE = "AUTOMATION_CONDITION_RULE_DELETE";
export const AUTOMATION_CONDITION_RULE_DELETE_SUCCESS = "AUTOMATION_CONDITION_RULE_DELETE_SUCCESS";
export const AUTOMATION_CONDITION_RULE_DELETE_FAILURE = "AUTOMATION_CONDITION_RULE_DELETE_FAILURE";

///automationexecution/data?scenario_id={id}
export const AUTOMATION_EXECUTION_LIST = "AUTOMATION_EXECUTION_LIST";
export const AUTOMATION_EXECUTION_LIST_SUCCESS = "AUTOMATION_EXECUTION_LIST_SUCCESS";
export const AUTOMATION_EXECUTION_LIST_FAILURE = "AUTOMATION_EXECUTION_LIST_FAILURE";
///automationexecution/data/{id}
export const AUTOMATION_EXECUTION_DATA = "AUTOMATION_EXECUTION_DATA";
export const AUTOMATION_EXECUTION_DATA_SUCCESS = "AUTOMATION_EXECUTION_DATA_SUCCESS";
export const AUTOMATION_EXECUTION_DATA_FAILURE = "AUTOMATION_EXECUTION_DATA_FAILURE";
///automationexecution/data (manual trigger)
export const AUTOMATION_EXECUTION_TRIGGER = "AUTOMATION_EXECUTION_TRIGGER";
export const AUTOMATION_EXECUTION_TRIGGER_SUCCESS = "AUTOMATION_EXECUTION_TRIGGER_SUCCESS";
export const AUTOMATION_EXECUTION_TRIGGER_FAILURE = "AUTOMATION_EXECUTION_TRIGGER_FAILURE";
///automationexecution/status/data
export const AUTOMATION_EXECUTION_STATUS_LIST = "AUTOMATION_EXECUTION_STATUS_LIST";
export const AUTOMATION_EXECUTION_STATUS_LIST_SUCCESS = "AUTOMATION_EXECUTION_STATUS_LIST_SUCCESS";
export const AUTOMATION_EXECUTION_STATUS_LIST_FAILURE = "AUTOMATION_EXECUTION_STATUS_LIST_FAILURE";
